<template>
    <div class="grid gap-y-1">
        <dt class="text-xs font-light text-gray-500 justify-center row-2 text-center">
            {{ props.label }}
        </dt>
        <dd class="flex items-center justify-center row-1">
            <slot />
        </dd>
    </div>
</template>

<script setup lang="ts">
type CardStatsProps = {
    label: string;
};

const props = defineProps<CardStatsProps>();
</script>
